import { COURSES, COMPARISON_ROWS } from "@/data/content";
import { Reveal } from "@/components/Reveal";

const ComparisonTable = () => (
  <div data-testid="course-comparison">
    {/* Desktop table */}
    <Reveal className="hidden md:block">
      <div className="overflow-hidden rounded-sm border border-line bg-white">
        <table className="w-full text-left">
          <thead>
            <tr className="border-b border-line">
              <th className="p-6 eyebrow font-normal">Compare</th>
              {COURSES.map((c) => (
                <th key={c.slug} className="p-6">
                  <span className="eyebrow block">{c.index} / {c.category}</span>
                  <span className="mt-1 block text-xl tracking-tight font-normal">{c.title}</span>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {COMPARISON_ROWS.map((row, i) => (
              <tr key={row.label} className={i < COMPARISON_ROWS.length - 1 ? "border-b border-line" : ""}>
                <td className="p-6 text-sm text-dim">{row.label}</td>
                {row.values.map((v, j) => (
                  <td key={j} className={`p-6 text-sm ${row.label === "Course Fee" ? "text-base font-medium" : "text-ink"}`}>{v}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Reveal>

    {/* Mobile stacked cards */}
    <div className="md:hidden space-y-4">
      {COURSES.map((c, i) => (
        <Reveal key={c.slug} delay={i * 0.08}>
          <div className="rounded-sm border border-line bg-white p-6" data-testid={`compare-card-${c.slug}`}>
            <span className="eyebrow">{c.index} / {c.category}</span>
            <p className="mt-1 text-2xl tracking-tight">{c.title}</p>
            <dl className="mt-5 space-y-3">
              {COMPARISON_ROWS.map((row, j) => (
                <div key={row.label} className="flex justify-between gap-4 text-sm border-b border-line pb-3 last:border-0 last:pb-0">
                  <dt className="text-dim">{row.label}</dt>
                  <dd className="text-right font-medium">{row.values[j]}</dd>
                </div>
              ))}
            </dl>
          </div>
        </Reveal>
      ))}
    </div>
  </div>
);

export default ComparisonTable;
